export const faqFlexData = () => {
  return [
    {
      title:
        "How many tickets can I purchase with my Flexible Season Membership?",
      htmlDescription:
        "You can purchase up to six (6) tickets for each game you wish to attend.",
    },
    {
      title: "What can I spend my membership credit on?",
      htmlDescription:
        "Your membership credit can be used towards discounted single-game tickets and parking passes for any regular season game you choose.",
    },
    {
      title: "How does auto-renewal work for flexible season members?",
      htmlDescription:
        "All Flexible Season Members are automatically enrolled into auto-renewal where we will automatically renew your Flexible Season Membership on an annual basis based on the four (4) month interest-free payment schedule on your invoice, unless you choose to opt out. There will be a 30 day opt out period beginning in the summer of 2024 for the 2025 season. You will receive an email regarding the 2025 season and the opt out period at that time.",
    },

  ];
};
